import { Logger } from "@/utils/logging";

const log = new Logger("<Map />");

export default log;
